import lottie from 'lottie-web';

$(() => {

    $('.lottie-logo').each((i, container) => {

        lottie.loadAnimation({
            container,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/img/website/InZaken-2023-Campagne-Landingspagina-Logo-2.json',
        });

    });

});
